import { useMutation } from '@tanstack/react-query';
import toast from 'react-hot-toast';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { message } from 'antd';

import HeaderSecondary from 'components/Header/headerSecondary';
import { passwordResetSublogin } from 'services/auth';
import ResetPasswordFormSubuser from 'components/forms/reset-password-form-subuser';
import { SubloginCustomError } from 'types';

const Sublogin = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const token = searchParams.get('activation') || '';

  const { mutate: passwordResetHandler,isLoading } = useMutation(passwordResetSublogin, {
    onSuccess() {
      toast('Your password was set! Please log in.', { icon: '✨' });
      navigate('/login', { replace: true });
    },
    onError(error: SubloginCustomError) {
      const errorMessage = error.response?.data.errors?.ConfirmPassword[0];
      message.error(errorMessage);
    },
  });

  return (
    <section className="box-border grid h-screen grid-cols-1 gap-[60px] overflow-hidden px-[24px] py-[24px]  md:pr-[24px] lg:grid-cols-2 xl:grid-cols-3 xl:gap-[120px] xl:pl-[156px]">
      <div className="col-span-1 flex flex-col gap-[96px]">
        <HeaderSecondary />
        <ResetPasswordFormSubuser
          passwordResetHandler={passwordResetHandler}
          token={token}
          isLoading={isLoading}
        />
      </div>
      <div className="cols-span-1 hidden h-full overflow-hidden rounded-[24px] lg:block xl:col-span-2">
        <img
          src="assets/login-cover.svg"
          alt="login-cover"
          className="h-full w-full object-cover"
        />
      </div>
    </section>
  );
};

export default Sublogin;
